import { Component, OnInit } from '@angular/core'
import { StringWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-string-widget',
  templateUrl: './string-widget.component.html',
  styleUrls: ['./string-widget.component.scss'],
})
export class StringWidgetComponent extends StringWidget {}
